import { Box, styled } from '@mui/material';

/**
 * The trigger and the summary as one group, and the popper's anchor. One anchor so a click on the summary
 * while the panel is open is not a click outside it; the panel still opens under the trigger, which is the
 * group's leading edge.
 */
export const FiltersAnchor = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  minWidth: 0
}));
